import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { TranslateService } from '@plugins/client/translate/services';
import { SDK } from '@plugins/middleware-sdk';

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  private readonly translate = inject(TranslateService);
  private readonly sdk = inject(SDK);
  private readonly locale = inject<Promise<string>>(LOCALE_ID);

  initialized: boolean;

  async canActivate(): Promise<boolean> {
    if (this.initialized) {
      return true;
    }
    this.sdk.initHeightObserver({ min: 400 });
    await this.setTranslations();
    this.initialized = true;
    return true;
  }

  private async setTranslations() {
    registerLocaleData(localeDe);
    const locale = await this.locale;
    await lastValueFrom(this.translate.use(locale));
  }
}
